import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ProcessRegModal from "../../../../modal/PC/gijun/ProcessRegModal";
import ProcessUpdateModal from "../../../../modal/PC/gijun/ProcessUpdateModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";

const Process = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [userTypeModalOption, setUserTypeModalOption] = useState([]);
    const [externalModalOption, setExternalModalOption] = useState([])
    const [keyword, setKeyword] = useState({
        search:''
    });
    const [isRegModalOpen, setRegModalOpen] = useState(false);
    const [isUpdateModalOpen, setUpdateModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectProcessID, setSelectProcessID] = useState('');

    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'updated',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color="primary" />} onClick={() => {UpdateClick(params)}} label="Edit" />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            (MenuDeleteExistYN === "Y"?
            {
                field: 'deleted',
                headerName: '삭제',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<DeleteIcon color={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y' ? "error" : "grey"} />} onClick={() => {DeleteClick(params)}} label="Delete" disabled={ MenuDeleteYN === "Y" && params.row.update_flag === 'Y'? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'process_id', width: 0, headerAlign: 'center' },
            { field: 'process_name', headerName: '공정명', width: 200, headerAlign: 'center', align:'left' },
            { field: 'process_external_yn', headerName: 'process_external_yn', width: 0, headerAlign: 'center', align:'center' },
            { field: 'process_external_yn_name', headerName: '공정유형', width: 100, headerAlign: 'center', align:'center' },
            { field: 'process_external_partner_id', headerName: 'process_external_partner_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'process_external_partner_name', headerName: '외부공정거래처', width: 150, headerAlign: 'center', align:'left' },
            { field: 'process_desc', headerName: '공정설명', width: 250, headerAlign: 'center', align:'left' },
            { field: 'reg_user_id', headerName: 'reg_user_id', width: 0, headerAlign: 'center' },
            { field: 'reg_user_name', headerName: '등록자', width: 130, headerAlign: 'center', align:'center' },
            { field: 'reg_datetime', headerName: '등록일시', width: 200, headerAlign: 'center', align:'center' },
            { field: 'update_user_id', headerName: 'update_user_id', width: 0, headerAlign: 'center' },
            { field: 'update_user_name', headerName: '수정자', width: 130, headerAlign: 'center', align:'center' },
            { field: 'update_datetime', headerName: '수정일시', width: 200, headerAlign: 'center', align:'center' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        process_name: true,
        process_external_yn: false,
        process_external_yn_name: true,
        process_external_partner_id: false,
        process_external_partner_name: true,
        process_desc: true,
        reg_user_id: false,
        reg_user_name: true,
        reg_datetime: true,
        update_user_id: false,
        update_user_name: true,
        update_datetime: true,
        deleted: true,
        updated: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleInit();
            handleView();
        }
    }, [MenuID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Process/List',
            {
            params : {
              search : keyword.search
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            const PermissionMap = {};
            response.data.forEach(row => {
                if (!PermissionMap[row.process_id]) {
                    PermissionMap[row.process_id] = [row.process_reg_user_id, row.process_update_user_id, row.process_user_id].includes(Number(localStorage.getItem('user_id')));
                }
            });

            const array = response.data.map((item, index) => ({
                id: item.process_id,
                process_name: item.process_name,
                process_external_yn: item.process_external_yn,
                process_external_yn_name: item.process_external_yn_name,
                process_external_partner_id: item.process_external_partner_id,
                process_external_partner_name: item.process_external_partner_name,
                process_desc: item.process_desc,
                reg_user_id: item.process_reg_user_id,
                reg_user_name: item.process_reg_user_name,
                reg_datetime: Moment(item.process_reg_datetime).format('YYYY-MM-DD HH:mm:ss'),
                update_user_id: item.process_update_user_id,
                update_user_name: item.process_update_user_name,
                update_datetime: (item.process_update_datetime === undefined?'':Moment(item.process_update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                update_flag: PermissionMap[item.process_id] ? 'Y' : 'N'
            }));
            setOriginRows(response.data);
            setRows([ ...new Set(array.map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });

    }

    const handleInitSelect = () => {

        var array = [
            {value:'N', label:'내부'}
            ,{value:'Y', label:'외부'}
        ];

         axios.get('/api/Common/CodeDetailList')
        .then((response) => { 
            
            var user_type_array_modal = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0020'){
                    user_type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }
            setUserTypeModalOption(user_type_array_modal);
        })
        .catch((error) => {
            console.log(error);
        });
        
        setExternalModalOption(array);
    }

    const handleInit = () => {
        setKeyword({
            search: ''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            process_name: true,
            process_external_yn: false,
            process_external_yn_name: true,
            process_external_partner_id: false,
            process_external_partner_name: true,
            process_desc: true,
            reg_user_id: false,
            reg_user_name: true,
            reg_datetime: true,
            update_user_id: false,
            update_user_name: true,
            update_datetime: true,
            deleted: true,
            updated: true,
            update_flag: false
        });
    };

    const handleReg = () => {
        setRegModalOpen(true);
        setModalTitle('공정 등록');
    };
    
    const UpdateClick = (object) => {
        setUpdateModalOpen(true);
        setModalTitle('공정 수정');
        setSelectProcessID(object.row.id);
    };

    const DeleteClick = (object) => {
        Swal.fire({
            title: '공정 '+object.row.process_name+' 삭제',
            html : '공정 '+object.row.process_name+'을(를) <span style="color:red; font-weight:bold;">삭제</span> 하시겠습니까?<br/>삭제하시면 복구 할 수 없습니다.',
            showCancelButton : true,
            confirmButtonColor : "#d33",
            confirmButtonText : "삭제",
            cancelButtonText : "닫기"
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                axios.post('/api/p/Process/Delete', new URLSearchParams({
                    delete_process_id: object.row.id
                }),
                { withCredentials: true })
                .then(function (response) {
                    if(response.status === 200){
                        Swal.fire({
                            title: '공정 '+object.row.process_name+' 삭제 완료',
                            text: '정상적으로 공정 '+object.row.process_name+'가 삭제 되었습니다.',
                            confirmButtonText: '확인',
                            timer: 5000,
                            timerProgressBar: true
                        }).then((result) => {
                            setRows((rows) => rows.filter((data) => data.id !== object.row.id));
                        });
                    }else{
                        appStore.capture();
                    }
                })
                .catch(function (error) {
                    appStore.capture();
                })
                .finally(() => {
                    appStore.setLoading(false);
                });
            }
        });
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };
    
    const handleRegSuccessSave = (regID) => {
        setModalTitle('공정 수정');
        setRegModalOpen(false);
        handleView();

        Swal.fire({
            title: '공정 등록 완료',
            text: '정상적으로 공정이 등록 되었습니다.',
            confirmButtonText: '확인',
            timer: 5000,
            timerProgressBar: true
        }).then((result) => {
            // 수정 화면 불러오기
            setUpdateModalOpen(true);
            setSelectProcessID(Number(regID));
        });
    };

    const handleExcel = () => {
        var filename = '공정관리'
        axios.get('/api/p/Process/Excel',
        {   
            params : { search : keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                    { MenuUpdateYN === "Y"?
                    <Button 
                        onClick={ handleReg }
                        className="btn-p btn-u"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                    </Button> : <></> }
                    {isRegModalOpen  && MenuUpdateYN === 'Y'&& (
                        <ProcessRegModal
                        onClose={() => {
                            setRegModalOpen(false);
                        }}
                        title={modalTitle}
                        handleRegSuccessSave={handleRegSuccessSave}
                        externalModalOption={externalModalOption}
                        userTypeModalOption={userTypeModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        />
                    )}
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div className="grid_sub" style={ { width: '100%' } }>
                    <DataGrid
                        className="grid_main"
                        rows={rows}
                        columns={columns}
                        slots={{
                            noRowsOverlay: GridNoRow,
                        }}
                        columnVisibilityModel={columnVisibilityModel}
                        AlternatingRowBackground="LavenderBlush"
                        rowsPerPageOptions={[20, 50, 100]}
                    />
                    {isUpdateModalOpen && (
                        <ProcessUpdateModal
                        onClose={() => {
                            setUpdateModalOpen(false);
                        }}
                        title={modalTitle}
                        id={selectProcessID}
                        handleView={handleView}
                        originRows={originRows.filter(row => String(row.process_id) === String(selectProcessID))}
                        externalModalOption={externalModalOption}
                        userTypeModalOption={userTypeModalOption}
                        MenuUpdateYN={MenuUpdateYN}
                        MenuDeleteYN={MenuDeleteYN}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default Process;
